<template>
  <component :is="theme === 'dark' ? 'LogoBigDark' : 'LogoBigLight'" v-if="$vuetify.breakpoint.mdAndUp"/>
  <component :is="theme === 'dark' ? 'LogoSmallDark' : 'LogoSmallLight'" v-else :style="`height: ${$vuetify.breakpoint.mdAndUp ? height : height - 20 }px;` + ``"/>
</template>
<script>
export default {
  props: {
    theme: String,
    height: [ Number, String ]
  },
  components: {
    LogoBigLight: () => import(`@/../public/goguest-large-light.svg`),
    LogoBigDark: () => import(`@/../public/goguest-large-dark.svg`),
    LogoSmallDark: () => import('@/../public/goguest-small-dark.svg'),
    LogoSmallLight: () => import('@/../public/goguest-small-light.svg')
  }
}
</script>

<style lang="scss">
</style>
